import { z } from 'zod';

/** A tag is its lower-case name (QZ-D40). */
export const tagNameSchema = z
  .string()
  .max(40)
  .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/);
export type TagName = string;

/** The 27 seed tags (QZ-D15), in order. */
export const SEED_TAGS = [
  'linguistics',
  'arithmetic',
  'geometry',
  'statistics',
  'biology',
  'physics',
  'chemistry',
  'history',
  'geography',
  'astronomy',
  'holidays',
  'religion',
  'literature',
  'cinema',
  'music',
  'mythology',
  'safety',
  'health',
  'finance',
  'crafts',
  'nutrition',
  'technology',
  'mechanics',
  'zoology',
  'ecology',
  'sports',
  'horticulture',
] as const;
